<template>
  <div class="products-page trash-page" dir="rtl">
    <div class="products-hero">
      <div>
        <p class="hero-kicker mb-1">برندها</p>
        <h1 class="mb-0">سطل زباله</h1>
      </div>
      <div class="hero-side">
        <div class="hero-count">
          <strong>{{ formatNumber(pagination && pagination.total != null ? pagination.total : items.length) }}</strong>
          <span>برند حذف‌شده</span>
        </div>
        <div class="hero-badge"><b-icon icon="trash"></b-icon></div>
      </div>
    </div>

    <div class="products-toolbar">
      <div class="products-toolbar-actions">
        <router-link class="products-tool-btn trash-back-btn" :to="{ name: 'Brand' }">
          <span>بازگشت به برندها</span>
          <b-icon icon="arrow-left"></b-icon>
        </router-link>
      </div>
      <div class="products-filter-bar">
        <div class="trash-filter-row">
          <label class="products-filter-field trash-search-field">
            <span><b-icon icon="search"></b-icon> جستجو در این صفحه</span>
            <input class="products-filter-input" v-model="searchInput" placeholder="نام یا slug..."
                   @keydown.enter.prevent>
          </label>
          <button v-if="searchInput" type="button" class="products-more-btn" @click="searchInput = ''">
            <b-icon icon="x-lg"></b-icon>
            <span>پاک کردن</span>
          </button>
        </div>
      </div>
    </div>

    <div class="products-list-panel">
      <div v-if="loading" class="products-loading">
        <div class="spinner-border" role="status"></div>
        <p class="mb-0">در حال بارگذاری...</p>
      </div>

      <div v-else-if="!filtered.length" class="products-empty">
        <i class="bi bi-trash"></i>
        <p class="mb-0">{{ query ? 'برندی با این عبارت پیدا نشد.' : 'سطل زباله خالی است.' }}</p>
        <router-link v-if="!query" class="products-empty-btn" :to="{ name: 'Brand' }">بازگشت به برندها</router-link>
      </div>

      <template v-else>
        <div class="forms-grid">
          <article v-for="brand in filtered" :key="brand.id" class="form-card trash-card"
                   :class="{ 'is-busy': busyId === brand.id }">
            <span class="trash-card__media">
              <img v-if="brand.image" :src="brand.image" alt="">
              <span v-else class="trash-card__placeholder"><b-icon icon="image"/></span>
            </span>
            <div class="form-card-top">
              <span class="form-id-chip">#{{ brand.id }}</span>
            </div>
            <div class="form-card-name">{{ brand.name }}</div>
            <div class="form-card-meta">
              <span dir="ltr"><b-icon icon="link-45deg"></b-icon> {{ brand.slug }}</span>
            </div>
            <div class="form-card-actions">
              <button type="button" class="form-action is-main" :disabled="busyId !== null" @click="restore(brand)">
                <b-spinner v-if="busyId === brand.id && busyAction === 'restore'" small/>
                <b-icon v-else icon="arrow-counterclockwise"></b-icon>
                <span>بازگردانی</span>
              </button>
              <button type="button" class="form-action is-danger" title="حذف دائمی" :disabled="busyId !== null"
                      @click="forceDelete(brand)">
                <b-spinner v-if="busyId === brand.id && busyAction === 'delete'" small/>
                <b-icon v-else icon="trash"></b-icon>
              </button>
            </div>
          </article>
        </div>
      </template>

      <div class="products-pager" v-if="!loading && pagination && pagination.last_page > 1">
        <m-pagination-400 class="text-center" :meta="pagination" :on-change-page="changePage"/>
      </div>
    </div>
  </div>
</template>

<script>
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import "../product/products-ui.css";
import "../Form/forms-ui.css";
import "../trash-ui.css";

export default {
  name: "Trash",
  data() {
    return {
      loading: true,
      items: [],
      pagination: null,
      page: 1,
      searchInput: '',
      busyId: null,
      busyAction: null,
    }
  },
  computed: {
    query() {
      return String(this.searchInput || '').trim().toLowerCase()
    },
    filtered() {
      const q = this.query
      if (!q) return this.items
      return this.items.filter(item =>
          String(item.name || '').toLowerCase().indexOf(q) > -1 || String(item.slug || '').toLowerCase().indexOf(q) > -1)
    },
  },
  methods: {
    formatNumber,
    async fetch(page) {
      this.loading = true
      this.page = page
      try {
        const res = await this.$store.dispatch('Brand/getTrash', page)
        const data = res && res.data ? res.data.data : null
        const list = data && data.data ? data.data : []
        this.items = Array.isArray(list) ? list.slice() : Object.values(list)
        this.pagination = data && data.meta ? data.meta : null
      } catch (e) {
        console.log(e)
        this.items = []
      } finally {
        this.loading = false
      }
    },
    changePage(page) {
      this.fetch(page)
      const currentRoute = this.$route
      this.$router.replace({name: currentRoute.name, query: {...currentRoute.query, page: page}}).catch(() => {})
    },
    removeLocal(brand) {
      this.items = this.items.filter(item => item.id !== brand.id)
      if (this.pagination && this.pagination.total) this.pagination = {...this.pagination, total: this.pagination.total - 1}
      if (!this.items.length && this.page > 1) this.changePage(this.page - 1)
    },
    async run(brand, action, storeAction, okText, errorText) {
      this.busyId = brand.id
      this.busyAction = action
      try {
        await this.$store.dispatch(storeAction, brand)
        this.removeLocal(brand)
        toast('عملیات با موفقیت انجام شد', okText, 'success')
      } catch (e) {
        toast('خطا', errorText, 'danger')
      } finally {
        this.busyId = null
        this.busyAction = null
      }
    },
    restore(brand) {
      if (!confirm(`برند «${brand.name}» بازگردانی شود؟`)) return
      this.run(brand, 'restore', 'Brand/restore', `برند «${brand.name}» بازگردانی شد.`, 'بازگردانی انجام نشد.')
    },
    forceDelete(brand) {
      if (!confirm(`برند «${brand.name}» برای همیشه حذف شود؟ این کار قابل بازگشت نیست.`)) return
      this.run(brand, 'delete', 'Brand/deleteBrand', `برند «${brand.name}» برای همیشه حذف شد.`, 'حذف دائمی انجام نشد.')
    },
  },
  mounted() {
    const page = Number(this.$route.query.page) || 1
    this.fetch(page)
  }
}
</script>
